import React from 'react';

import config from '.../../../config';

import FeedGrid, { fragments } from '../Feed/FeedGrid';
import { useFeatureToggles } from '../../contexts/FeatureToggle';
import { useWorkRecommendations } from '../../containers/apollo/withWorkRecommendations';

const DEFAULT_EXPERIENCE_TITLE = config('defaultExperienceTitle');
const NORMAL_LIMIT = 32;
const PRELOAD_LIMIT = 18;
const MOBILE_PAGE_SIZE = 20;
const DESKTOP_PAGE_SIZE = 60;

const WorkRecommendationFeedGrid = ({
  browser,
  analyticsLabel,
  logComponentInView,
  userInfo
}) => {
  const toggles = useFeatureToggles();
  const {
    works,
    loading,
    error,
    fetchingMore,
    refetch,
    hasMore,
    fetchMore
  } = useWorkRecommendations({
    limit: 24,
    userInfo,
    fragments,
    ssr: true
  });

  const limit = toggles.limit || NORMAL_LIMIT;
  const preloadLimit = toggles.preloadLimit || PRELOAD_LIMIT;

  const experienceTitle = toggles.recommendations || DEFAULT_EXPERIENCE_TITLE;

  return (
    <FeedGrid
      experienceTitle={experienceTitle}
      limit={limit}
      preloadLimit={preloadLimit}
      pageSize={browser.is.large ? DESKTOP_PAGE_SIZE : MOBILE_PAGE_SIZE}
      analyticsLabel={analyticsLabel}
      useModal
      onLoadingShowed={logComponentInView('explore-feed', true)}
      onContentShowed={logComponentInView('explore-feed', false)}
      userInfo={userInfo}
      loading={loading}
      error={error}
      items={works.map(work => ({ work }))}
      fetchingMore={fetchingMore}
      refetch={refetch}
      hasMore={hasMore}
      fetchMore={fetchMore}
      autoPaginate
    />
  );
};

export default WorkRecommendationFeedGrid;
